/* Org messaging (Inbox, S1 + S2). On by default — the backend gates the
 * pilot with its own allowlist, and an older server just yields the empty
 * state. Build with `REACT_APP_INBOX_ENABLED=false` to hide the route, the
 * sidebar entry, the unread badge and the "Message" actions entirely. */
export const INBOX_ENABLED = process.env.REACT_APP_INBOX_ENABLED !== 'false';
